import React from "react";
import { FacilityStatus, facilityStatusNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import SearchSelectBox from "../SearchSelectBox";

const FacilityStatusSelect = (props:any) => {
    const { value, manageSelect, isError, errorMessage, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
    { value: FacilityStatus.FS_OWNED, name: t(facilityStatusNaming[FacilityStatus.FS_OWNED]) },
    { value: FacilityStatus.FS_PRIORITY, name: t(facilityStatusNaming[FacilityStatus.FS_PRIORITY]) },
    { value: FacilityStatus.FS_PUBLIC, name: t(facilityStatusNaming[FacilityStatus.FS_PUBLIC]) },
  ];

    return (
        <>
            <SearchSelectBox
            options={options}
            selectedValue={value}
            manageSelect={(e:any) => {manageSelect(e.value)}}
            label={t('DC_6_FACILITY_STATUS')}
            isError={isError}
            errorMessage={errorMessage}
            disabled={isReadOnly}
            />
        </>
    );
}

export default FacilityStatusSelect;